module.exports = "https://hwyhw-static.smarket.net.cn/519/seminar/2202102963240899/minisite/a204dcdadfd5ec43875e2d760af00039.png";